<template>
  <b-modal
    v-model="show"
    :title="
      $route.path === '/settings' ? 'Profile Picture Upload' : 'Upload Photo'
    "
    centered
    hide-footer
  >
    <div v-if="$route.path === '/settings'" class="mb-4 text-muted">
      Upload a profile picture, passport style, so we can quickly create an ID
      for you when needed.
    </div>

    <b-card
      no-body
      v-cloak
      class="rounded-0 border-0 mx-0"
      @drop.prevent="onFileChange"
      @dragover.prevent
    >
      <div v-if="imgSrc">
        <vue-cropper
          ref="cropper"
          :guides="true"
          drag-mode="crop"
          :src="imgSrc"
          :aspect-ratio="1 / 1"
          :initial-aspect-ratio="1 / 1"
          :container-style="imageContainer"
        />
      </div>

      <div
        class="text-center select-container"
        @click="launchFilePicker"
        v-else
      >
        <b-img
          class="mb-2"
          :src="require('@/assets/icons/file-upload.svg')"
          :srcset="`${require('@/assets/icons/file-upload.svg')}`"
        />
        <b-button class="px-5 btn" variant="primary" :style="'height: 56px;'">
          Upload from device
        </b-button>
        <p class="text-center">or drag them in</p>
        <input
          type="file"
          ref="filePicker"
          @change="onFileChange"
          style="display: none;"
          accept="image/*"
        />
      </div>

      <div class="my-4 mx-0">
        <b-button
          class="ml-2 px-5 float-right"
          variant="primary"
          :loading="loading"
          :disabled="!this.imgSrc"
          :class="{ 'btn-disabled': !this.imgSrc }"
          :style="'height: 56px;'"
          @click="save"
        >
          <b-spinner small v-if="loading"></b-spinner>
          <div v-else>Submit</div>
        </b-button>
      </div>
    </b-card>
  </b-modal>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  components: {
    VueCropper
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      show: this.value,
      loading: false,
      imgSrc: null,
      imageContainer: { maxHeight: '450px' }
    }
  },

  methods: {
    launchFilePicker() {
      this.$refs.filePicker.click()
    },

    onFileChange(e) {
      const file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0]
      if (file && this.isImage(file)) {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = e => {
          this.imgSrc = e.target.result
        }
      }
    },

    save() {
      this.$refs.cropper.getCroppedCanvas().toBlob(blob => {
        this.loading = true
        this.$emit('change', blob)
      })
    },

    closeModal() {
      this.loading = false
      this.imgSrc = null
      this.$emit('close')
    },

    isImage(file) {
      return file && file['type'].split('/')[0] === 'image'
    }
  },

  created() {
    this.$root.$on('fileChange', e => {
      this.onFileChange(e)
    })

    this.$root.$on('uploadComplete', () => {
      this.loading = false
      this.imgSrc = null
      this.$emit('success')
    })

    this.$root.$on('bv::modal::hide', () => {
      this.closeModal()
    })
  },

  watch: {
    value(val) {
      this.show = val
    },

    show(val) {
      this.imgSrc = null
    }
  }
}
</script>

<style scoped>
.select-container {
  cursor: pointer;
  background: #eaf3ff;
  border: 1px dashed #006cff;
  border-radius: 8px;
  padding: 80px;
}
.btn.btn-outlined {
  padding: 4px 32px;
}
.btn {
  height: 36px;
}
</style>
